/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
/**
 * Hard-coded in the fluent DetailsList rows.
 * https://github.com/microsoft/fluentui/blob/547d0184dbf41e4b42ffb13f6db2dac0fd85f70a/packages/react/src/components/DetailsList/DetailsRow.styles.ts#L40
 */
export const DEFAULT_ROW_HEIGHT = 42
/**
 * Hard-coded in the fluent DetailsList rows
 */
export const COMPACT_ROW_HEIGHT = 32

/**
 * Hard-coded in the fluent DetailsList cell header
 */
export const HEADER_WIDTH_PADDING = 20

/**
 * Includes text height and DetailsList hard-coded padding
 */
export const BASE_HEADER_HEIGHT = 33
export const DEFAULT_COLUMN_WIDTH = 100

export const STATS_HEADER_ITEM_HEIGHT = 14

export const HISTOGRAM_HEADER_PADDING = 8
export const HISTOGRAM_HEADER_HEIGHT = 20
export const HISTOGRAM_HEADER_COMPACT_HEIGHT = 16

export const ROW_NUMBER_COLUMN_NAME = '__rowNumber__'
